import React from 'react';
import { useTranslation } from 'react-i18next';

const PageNotFound = () => {
  const { t } = useTranslation();
  return <h1>{t('404-Error')}</h1>;
};

export default PageNotFound;
